import * as React from 'react'
import { Button, ButtonToolbar } from 'react-bootstrap'
import LocalizationStore from '../../../Stores/LocalizationStore'
import { inject, observer } from 'mobx-react'
import Form, { IChangeEvent } from 'react-jsonschema-form'
import { UICommentFormSchema, getCommentFormSchema } from '../../../Model/CommentForm'
import HttpActionsService from '../../../Services/HttpActionsService'

export interface IQuestionnaireAddCommentsViewProps {
    qId: string,
    className?: string,
    localizationStore?: LocalizationStore,
    httpActionsService?: HttpActionsService
}

@inject('httpActionsService')
@inject('localizationStore')
@observer
export default class QuestionnaireAddCommentsView extends React.Component<IQuestionnaireAddCommentsViewProps> {

    uiSchema: any = UICommentFormSchema

    handleOk(e: IChangeEvent<any>, context: QuestionnaireAddCommentsView) {
        this.props.httpActionsService!
            .addComment(this.props.qId, e.formData['comment'])

        context.setState({ default: '' })
    }

    render() {
        const { localizationStore } = this.props
        return (
            <div className={this.props.className} >
                <div className="container">
                    <div className="row">
                        <div className="col-12 formWrapper">
                            <Form
                                onSubmit={(e) => { this.handleOk(e, this) }}
                                schema={getCommentFormSchema()}
                                uiSchema={this.uiSchema}
                            >
                                <ButtonToolbar>
                                    <Button
                                        type="submit"
                                        bsStyle="success"
                                    >
                                        {localizationStore!.t!('Add comment')}
                                    </Button>
                                </ButtonToolbar>
                            </Form>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Views/PartialViews/Questionnaire/QuestionnaireAddCommentsView.tsx